// @version V0.0.3 [Tuesday - 20201117_175009] : added getPageByRoot
// @version V0.0.2 [Wednesday - 20201111_211651] : change the way of root
// @version V0.0.1 [Tuesday - 20201103_092924] : init

const getDefaultState = () => {
    return {
        pages: [],
    }
}

import {
    sendRequest
} from "./../../api";

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        resetState(state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        setPage(state, payload) {
            state.pages = payload;
        },
    
    },
    // can async
    actions: {
        loadPage({commit}) {
            sendRequest('page', {}, 'get', (response) => commit('setPage', response),() => {}, () => {}, false, false);
        },
        
    },
    // call variable with custom display
    getters: {
        pageNested : (state) => ({ showAll }) => {
            let pageRoots = _.filter(state.pages, function(item) {
                if (showAll) {
                    return item.root_key == 'root'
                } else {
                    return item.root_key == 'root' && item.hide === false
                }
            })

            let r = [];
            _.each(pageRoots, function(pageRoot) {
                r.push(generateNesting(pageRoot, state.pages))
            })

            function generateNesting(page, fullList) {
                let key = page.key;
                // identify if have children
                let children = _.filter(fullList, function(item) {
                    if (showAll) {
                        return item.root_key == key
                    } else {
                        return item.root_key == key && item.hide === false
                    }
                })
                // ->
                if (children.length > 0) {
                    let c = [];
                    _.each(children, function(item) {
                        c.push(generateNesting(item, fullList))
                    })
                    page.children = c;
                    return page;
                } else {
                    return page;
                }
            }
            return r;
        },
        getPageByRoot : (state) => (rootKey) => {
            return state.pages.filter(p => p.root_key == rootKey)
        }, 
        getPageByUrl : (state) => (url) => {
            // return _.find(state.pages, {uri: url})
            return state.pages.find(page => page.uri == url) 
        }
    }
})
